<template>
    <table class="uk-table">
        <thead>
            <tr>
                <th
                    v-for="(column, field) in sampleColumns"
                    :key="field"
                >
                    {{ column.label }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="row in sampleRows"
                :key="row.id"
            >
                <td
                    v-for="(column, field) in sampleColumns"
                    :key="field"
                >
                    {{ row[field] }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "ExportSamples",
    props: {
        sampleColumns: {
            type: Object,
            required: true
        },
        sampleRows: {
            type: Array,
            required: true
        }
    }
}
</script>
